/* eslint-disable no-console */
/* eslint-disable prettier/prettier */
import React, { useState, useEffect } from "react";
import "./stylesCotizadorProgrammaticHorasOn.scss";

export const CotizadorProgrammaticHorasOn = ({
  onHorasChange,
  onProgrammaticChange,
  onDigitalChange,
  defaultHoras = 0,
  defaultIntervalos = [],
  defaultOptions = [],
  isProgrammaticSelected,
  isDigitalSelected,
  isEditMode = false,
}) => {
  const [selectedIntervals, setSelectedIntervals] = useState(defaultIntervalos);
  const [tradicionalDigital, setTradicionalDigital] = useState(isEditMode ? (isDigitalSelected || false) : false);
  const [programmatic, setProgrammatic] = useState(isEditMode ? (isProgrammaticSelected || false) : false);
  const [selectedTimeMode, setSelectedTimeMode] = useState("");
  const [selectedOptions, setSelectedOptions] = useState(isEditMode ? defaultOptions : []);

  // Sync local state with parent props - Run only when props change
  useEffect(() => {
    let newTradicionalDigital = tradicionalDigital;
    let newProgrammatic = programmatic;

    if (isEditMode) {
      // Edit mode: Mutual exclusivity
      if (isDigitalSelected && !tradicionalDigital) {
        newTradicionalDigital = true;
        newProgrammatic = false;
      } else if (isProgrammaticSelected && !programmatic) {
        newTradicionalDigital = false;
        newProgrammatic = true;
      }
    } else {
      // Creation mode: Allow both to be checked
      newTradicionalDigital = isDigitalSelected || false;
      newProgrammatic = isProgrammaticSelected || false;
    }

    if (newTradicionalDigital !== tradicionalDigital) {
      setTradicionalDigital(newTradicionalDigital);
    }
    if (newProgrammatic !== programmatic) {
      setProgrammatic(newProgrammatic);
    }

    // Set selectedTimeMode based on defaults only if not already set
    if (!selectedTimeMode) {
      if (defaultOptions.length > 0) {
        setSelectedTimeMode(defaultOptions[0].label);
        setSelectedOptions(defaultOptions);
        setSelectedIntervals([]);
      } else if (defaultIntervalos.length > 0) {
        setSelectedTimeMode("INTERVALOS");
        setSelectedIntervals(defaultIntervalos);
        setSelectedOptions([]);
      } else if (isEditMode && isDigitalSelected && selectedOptions.length === 0 && defaultOptions.length === 0) {
        const defaultOption = { label: "FULL DAY | 07:00 a 21:00", hours: 14 };
        setSelectedTimeMode(defaultOption.label);
        setSelectedOptions([defaultOption]);
      }
    }
  }, [isDigitalSelected, 
    isProgrammaticSelected, 
    defaultOptions, 
    defaultIntervalos, 
    isEditMode]); // Dependencias solo props externas, no states internos para evitar loop

  // Update Horas ON when options or intervals change
  useEffect(() => {
    const totalHours = selectedOptions.length > 0 ? selectedOptions[0].hours : selectedIntervals.length / 2 || 0;
    onHorasChange(totalHours, selectedIntervals, selectedOptions);
  }, [selectedIntervals, selectedOptions, onHorasChange]); // Dependencias completas y estables

  // Separate effect for updating when intervals change and mode is INTERVALOS
  useEffect(() => {
    if (selectedTimeMode === "INTERVALOS") {
      onHorasChange(selectedIntervals.length / 2 || 0, selectedIntervals, []);
    }
  }, [selectedIntervals, selectedTimeMode, onHorasChange]); // Dependencias completas y estables

  const handleCheckboxChange = (interval) => {
    setSelectedIntervals((prevSelectedIntervals) => {
      const selectedIndex = prevSelectedIntervals.indexOf(interval);
      return selectedIndex === -1
        ? [...prevSelectedIntervals, interval]
        : [
            ...prevSelectedIntervals.slice(0, selectedIndex),
            ...prevSelectedIntervals.slice(selectedIndex + 1),
          ];
    });
  };

  const handleTradicionalDigital = (event) => {
    const isChecked = event.target.checked;
    setTradicionalDigital(isChecked);

    if (isEditMode) {
      // Edit mode: Mutual exclusivity
      if (isChecked) {
        setProgrammatic(false);
        onDigitalChange(true);
        onProgrammaticChange(false);
      } else {
        onDigitalChange(false);
      }
    } else {
      // Creation mode: Allow both to be checked
      onDigitalChange(isChecked);
    }
  };

  const handleProgrammatic = (event) => {
    const isChecked = event.target.checked;
    setProgrammatic(isChecked);

    if (isEditMode) {
      // Edit mode: Mutual exclusivity
      if (isChecked) {
        setTradicionalDigital(false);
        onProgrammaticChange(true);
        onDigitalChange(false);
      } else {
        onProgrammaticChange(false);
      }
    } else {
      // Creation mode: Allow both to be checked
      onProgrammaticChange(isChecked);
    }
  };

  const handleTimeModeChange = (item) => {
    if (selectedTimeMode === item.label) {
      // Allow deselection if already selected, but for consistency, maybe not; assuming exclusive, no deselection
      return;
    }
    setSelectedTimeMode(item.label);
    if (item.type === "preset") {
      const option = { label: item.label, hours: item.hours };
      setSelectedOptions([option]);
      setSelectedIntervals([]);
      onHorasChange(item.hours, [], [option]);
    } else if (item.type === "intervals") {
      setSelectedOptions([]);
      // Do not clear intervals, keep previous if any
      onHorasChange(selectedIntervals.length / 2 || 0, selectedIntervals, []);
    }
  };

  const generateTimeIntervals = () => {
    const intervals = [];
    for (let hour = 7; hour < 21; hour++) {
      for (let minute = 0; minute < 60; minute += 30) {
        const startTime = `${hour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;
        let endTimeHour = hour;
        let endTimeMinute = minute + 30;
        if (endTimeMinute === 60) {
          endTimeHour++;
          endTimeMinute = 0;
        }
        const endTime = `${endTimeHour.toString().padStart(2, "0")}:${endTimeMinute.toString().padStart(2, "0")}`;
        const intervalLabel = `${startTime} - ${endTime}`;
        intervals.push(
          <div key={intervalLabel}>
            <input
              type="checkbox"
              id={intervalLabel}
              checked={selectedIntervals.includes(intervalLabel)}
              onChange={() => handleCheckboxChange(intervalLabel)}
              style={{ width: "15px", height: "15px", marginRight: "10px", marginLeft: "1rem", marginBottom: "10px" }}
            />
            <label htmlFor={intervalLabel}>{intervalLabel}</label>
          </div>
        );
      }
    }
    return intervals;
  };

  const timeOptions = [
    { label: "FULL DAY | 07:00 a 21:00", hours: 14, type: "preset" },
    { label: "AM | 07:00 a 14:00", hours: 7, type: "preset" },
    { label: "PM | 14:00 a 21:00", hours: 7, type: "preset" },
    { label: "INTERVALOS", hours: null, type: "intervals" },
  ];

  return (
    <div className="horason">
      <p className="titulohorason">EXHIBICIÓN</p>
      <hr />
      <div className="seleccion">
        <label>
          <input
            type="checkbox"
            className="cb123"
            checked={tradicionalDigital}
            onChange={handleTradicionalDigital}
            disabled={isEditMode && isProgrammaticSelected} // Disable only in edit mode
          />
          DIGITAL
          <br />
        </label>
      </div>
      <div className="seleccion">
        <label>
          <input
            type="checkbox"
            className="cb123"
            checked={programmatic}
            onChange={handleProgrammatic}
            disabled={isEditMode && isDigitalSelected} // Disable only in edit mode
          />
          PROGRAMMATIC
        </label>
      </div>
      <hr />
      {(tradicionalDigital || programmatic) && (
        <div style={{ display: "flex", justifyContent: "center", marginBottom: "10px" }}>
          <div className="mt-2">
            {timeOptions.map((item) => (
              <div key={item.label}>
                <input
                  type="checkbox"
                  id={item.label}
                  checked={selectedTimeMode === item.label}
                  onChange={() => handleTimeModeChange(item)}
                  style={{ width: "15px", height: "15px", marginRight: "10px", marginLeft: "1rem", marginBottom: "10px" }}
                />
                <label htmlFor={item.label}>{item.label}</label>
              </div>
            ))}
            {selectedTimeMode === "INTERVALOS" && (
              <div className="mt-2">
                <hr />
                {generateTimeIntervals()}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};